/** @graphql cc **/

import gql from 'graphql-tag';

export const HomeRecentUserPreferencesQuery = gql`
	query HomeRecentUserPreferencesQuery {
		userPreferences {
			recentFilter
		}
	}
`;

export const HomeRecentUserPreferencesMutation = gql`
	mutation HomeRecentUserPreferencesMutation($filter: RecentFilter) {
		updateUserPreferences(userPreferences: { recentFilter: $filter }) {
			recentFilter
		}
	}
`;

// When modifying any fragment (ConfluencePage, ConfluenceBlogPost, ConfluenceWhiteboard, etc.), make sure
// to update all instances of that fragment used in this query. Otherwise, useQuery will return undefined and break the experience.
// Fragment spreads will be reintroduced via Relay: https://hello.atlassian.net/wiki/spaces/UIP/blog/2024/10/21/4166388009/GraphQL+Codemods+and+U+IP
export const HomeRecentActivityQuery = gql`
	query HomeRecentActivityQuery(
		$cloudId: ID!
		$first: Int
		$after: String
		$eventTypes: [String!]
		$objectTypes: [String!]
	) {
		activity {
			myActivity {
				all(
					filter: {
						type: AND
						rootContainerIds: [$cloudId]
						arguments: {
							products: ["CONFLUENCE"]
							objectTypes: $objectTypes
							eventTypes: $eventTypes
						}
					}
					first: $first
					after: $after
				) {
					edges {
						cursor
						node {
							id
							object {
								id
								data {
									... on ConfluencePage {
										id
										title
										type
										subtype
										pageStatus: status
										createdAt
										links {
											webUi
											editUi
										}
										body {
											excerpt
										}
										viewer {
											favoritedSummary {
												isFavorite
											}
										}
										commentCountSummary {
											total
										}
										space {
											id
											alias
											key
											name
										}
										likesSummary {
											count
										}
										editorVersion: properties(keys: ["editor"]) {
											value
										}
										metadata {
											titleEmojiDraft {
												value
											}
											titleEmojiPublished {
												value
											}
										}
									}
									... on ConfluenceBlogPost {
										id
										title
										type
										blogStatus: status
										createdAt
										links {
											webUi
											editUi
										}
										body {
											excerpt
										}
										viewer {
											favoritedSummary {
												isFavorite
											}
										}
										commentCountSummary {
											total
										}
										space {
											id
											alias
											key
											name
										}
										likesSummary {
											count
										}
										editorVersion: properties(keys: ["editor"]) {
											value
										}
										metadata {
											titleEmojiDraft {
												value
											}
											titleEmojiPublished {
												value
											}
										}
									}
									... on ConfluenceWhiteboard {
										id
										title
										type
										status
										links {
											webUi
										}
										viewer {
											favoritedSummary {
												isFavorite
											}
										}
										commentCountSummary {
											total
										}
										space {
											id
											alias
											key
											name
										}
									}
									... on ConfluenceDatabase {
										id
										title
										type
										status
										links {
											webUi
										}
										viewer {
											favoritedSummary {
												isFavorite
											}
										}
										commentCountSummary {
											total
										}
										space {
											id
											alias
											key
											name
										}
									}
									... on ConfluenceEmbed {
										id
										title
										type
										status
										links {
											webUi
										}
										viewer {
											favoritedSummary {
												isFavorite
											}
										}
										commentCountSummary {
											total
										}
										space {
											id
											alias
											key
											name
										}
										metadata {
											titleEmojiDraft {
												value
											}
											titleEmojiPublished {
												value
											}
										}
									}
									... on ConfluenceInlineComment {
										id
										commentId
										container {
											... on ConfluencePage {
												id
												title
												type
												subtype
												pageStatus: status
												createdAt
												links {
													webUi
													editUi
												}
												body {
													excerpt
												}
												viewer {
													favoritedSummary {
														isFavorite
													}
												}
												commentCountSummary {
													total
												}
												space {
													id
													alias
													key
													name
												}
												likesSummary {
													count
												}
												editorVersion: properties(keys: ["editor"]) {
													value
												}
												metadata {
													titleEmojiDraft {
														value
													}
													titleEmojiPublished {
														value
													}
												}
											}
											... on ConfluenceBlogPost {
												id
												title
												type
												blogStatus: status
												links {
													webUi
													editUi
												}
												body {
													excerpt
												}
												viewer {
													favoritedSummary {
														isFavorite
													}
												}
												commentCountSummary {
													total
												}
												space {
													id
													alias
													key
													name
												}
												editorVersion: properties(keys: ["editor"]) {
													value
												}
												metadata {
													titleEmojiDraft {
														value
													}
													titleEmojiPublished {
														value
													}
												}
											}
											... on ConfluenceWhiteboard {
												id
												title
												type
												status
												links {
													webUi
												}
												viewer {
													favoritedSummary {
														isFavorite
													}
												}
												commentCountSummary {
													total
												}
												space {
													id
													alias
													key
													name
												}
											}
										}
									}
									... on ConfluenceFooterComment {
										id
										commentId
										container {
											... on ConfluencePage {
												id
												title
												type
												subtype
												pageStatus: status
												createdAt
												links {
													webUi
													editUi
												}
												body {
													excerpt
												}
												viewer {
													favoritedSummary {
														isFavorite
													}
												}
												commentCountSummary {
													total
												}
												space {
													id
													alias
													key
													name
												}
												likesSummary {
													count
												}
												editorVersion: properties(keys: ["editor"]) {
													value
												}
												metadata {
													titleEmojiDraft {
														value
													}
													titleEmojiPublished {
														value
													}
												}
											}
											... on ConfluenceBlogPost {
												id
												title
												type
												blogStatus: status
												links {
													webUi
													editUi
												}
												body {
													excerpt
												}
												viewer {
													favoritedSummary {
														isFavorite
													}
												}
												commentCountSummary {
													total
												}
												space {
													id
													alias
													key
													name
												}
												editorVersion: properties(keys: ["editor"]) {
													value
												}
												metadata {
													titleEmojiDraft {
														value
													}
													titleEmojiPublished {
														value
													}
												}
											}
											... on ConfluenceWhiteboard {
												id
												title
												type
												status
												links {
													webUi
												}
												viewer {
													favoritedSummary {
														isFavorite
													}
												}
												commentCountSummary {
													total
												}
												space {
													id
													alias
													key
													name
												}
											}
										}
									}
								}
							}
							event {
								id
								timestamp
								eventType
							}
						}
					}
					pageInfo {
						hasNextPage
						endCursor
					}
				}
			}
		}
	}
`;

export const HomeRecentCreatedQuery = gql`
	query HomeRecentCreatedQuery($cql: String!, $cqlcontext: String!, $first: Int, $after: String) {
		search: confluence_search(cql: $cql, cqlcontext: $cqlcontext, first: $first, after: $after) {
			nodes {
				content {
					id
					title
					type
					subType
					links {
						webui
						editui
					}
					excerpt(length: 372)
					metadata {
						currentuser {
							favourited {
								isFavourite
							}
						}
						comments {
							commentsCount
						}
					}
					space {
						alias
						id
						key
						name
					}
					likes {
						count
					}
					status
					blank
					metadata {
						createdDate
					}
					editorVersion: properties(key: "editor") {
						nodes {
							id
							key
							value
						}
					}
					emoji: properties(keys: ["emoji-title-published"]) {
						nodes {
							id
							value
							key
						}
					}
					history {
						createdBy {
							... on KnownUser {
								accountId
							}
						}
					}
					version {
						by {
							... on KnownUser {
								accountId
							}
						}
					}
				}
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;
